module.exports = __webpack_public_path__ + "img/step03_b_stand_basic_left_rear_leg.a5e73c5e.png";